import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { fetchPreOrders, fetchSalesOrderDetail } from '../../actions/preOrders_actions';

import PreOrders from '../../components/Sales/preOrders';

const preOrders = reduxForm({
  form: 'preOrders',
  destroyOnUnmount: false,
})(PreOrders);

function mapStateToProps(state) {
  return {
    currentSalesOrder: state.preOrders.currentSalesOrder,
    preOrders: state.preOrders.all,
    isLoading: state.preOrders.isLoading,
    error: state.preOrders.error,
    salesOrderDetail: state.preOrders.currentSalesOrderDetail,
    salesOrderIsLoading: state.preOrders.detailIsLoading,
    salesOrderError: state.preOrders.detailError,
    salesOrdersFilter: state.preOrders.salesOrdersFilter,
    userPermissions: state.auth.userPermissions,
    users: state.settings.all,
    usersIsLoading: state.settings.isLoading,
    usersError: state.settings.error,
    msoTotalPages: state.preOrders.msoTotalPages,

    requestingShippingList: state.preOrders.requestingShippingList,
    shippingListPDF: state.preOrders.shippingListPDF,

    requestingPickingList: state.preOrders.requestingPickingList,
    pickingListPDF: state.preOrders.pickingListPDF,

    requestingPackingList: state.preOrders.requestingPackingList,
    packingListPDF: state.preOrders.packingListPDF,

    requestingSalesOrderPDF: state.preOrders.requestingSalesOrderPDF,
    salesOrderPDF: state.preOrders.salesOrderPDF,

    requestingBolIdPDF: state.preOrders.requestingBolIdPDF,
    bolIdPDF: state.preOrders.bolIdPDF,
    requestingBolWithoutLogPDF: state.preOrders.requestingBolWithoutLogPDF,
    bolWithoutLogPDF: state.preOrders.bolWithoutLogPDF,
    requestingBolLabel: state.preOrders.requestingBolLabel,
    bolLabel: state.preOrders.bolLabel,
    requestingBolFbaPDF: state.preOrders.requestingBolFbaPDF,
    bolFbaPDF: state.preOrders.bolFbaPDF,
    bolAddress: state.preOrders.bolAddress,
    quoteLoading: state.preOrders.quoteLoading,
  };
}

export default connect(mapStateToProps, {
  fetchPreOrders,
  fetchSalesOrderDetail,
})(preOrders);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/preOrders.jsx